"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames = require("classnames");
exports.withLabel = function (Component) { return function (props) {
    var id = props.id, label = props.label, required = props.required, _a = props.showLabel, showLabel = _a === void 0 ? true : _a, rest = __rest(props, ["id", "label", "required", "showLabel"]);
    var style = classnames('with-label', 'p-t-grey40', 'p-m-v-sm', {
        'sr-only': !showLabel
    });
    return (React.createElement("div", null,
        React.createElement("label", { htmlFor: id, className: style },
            label,
            required && React.createElement("span", { className: "p-t-error50" }, "*")),
        React.createElement(Component, __assign({ id: id, required: required }, rest))));
}; };
exports.default = exports.withLabel;
//# sourceMappingURL=withLabel.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/textbox/build/control/hocs/common/withLabel.js
// module id = 913
// module chunks = 0